<template>
    <b-form-group :description="item.helpText" v-if="!('visible' in item) || item.visible" 
                 :class="{'mandatory-form-group': item.mandatory}">
        <b-form-checkbox v-model="item.value"
                         value="1"
                         unchecked-value="0"
                         :id="item.identifier"
                         :class="{'mandatory-checkbox': item.mandatory}"
                         @change="valueChanged">

            <span>{{item.title || item.field }}<span v-if="item.mandatory" class="mandatory-indicator"><span class="required-text">(Required)</span></span></span>

        </b-form-checkbox>
    </b-form-group>
</template>

<script>
    import FormItem from "./FormItem";
    import { debounce } from 'lodash';
    import { EventBus } from "../../event-bus";

    export default {
        name: "CheckboxFormItem",
        extends: FormItem,
        data() {
            return {
                saving: false,
                saved: false,
            }
        },
        created() {
            // Create the debounced function once during component creation
           this.debouncedSave = debounce(() => {
                this.saved = true;
                this.saving = false;
                setTimeout(() => {
                    this.saved = false;
                },1000);
            }, 1000);
        },
        methods: {
            valueChanged() {
                this.saving = true;
                this.saved = false;
                EventBus.$emit('form-saving-started');
                this.debouncedSave();
            }
        }
    }
</script>

<style>
    .custom-checkbox label.custom-control-label {
        font-weight: normal;
    }
    
    .mandatory-form-group {
        padding-left: 8px;
        border-left: 3px solid #f8d7da;
        margin-left: -11px;
    }
    
    .mandatory-checkbox {
        background-color: #fff8f8;
        padding: 5px 8px;
        border-radius: 4px;
    }

    .mandatory-indicator {
        color: #d9534f;
        font-weight: bold;
        margin-left: 3px;
    }
    
    .required-text {
        font-size: 0.85em;
        font-style: italic;
        font-weight: normal;
    }
</style>
